import { combineReducers } from 'redux';
import toasterReducer from './toaster/slice';
import notificationReducer from './notification/slice';
import bulkOperationsReducer from './bulk/operations/slice';
import bulkActionsReducer from './bulk/actions/slice';
import filterReducer from './filter/slice';
import pendingAiSummariesReducer from './pendingAiSummaries/slice';
import pendingBulkTakedownsReducer from './pendingBulkTakedowns/slice';
import pendingTakedownStatusUpdatesReducer from './pendingTakedownStatusUpdates/slice';

const appReducer = combineReducers({
  toaster: toasterReducer,
  notification: notificationReducer,
  bulkOperations: bulkOperationsReducer,
  bulkActions: bulkActionsReducer,
  filterList: filterReducer,
  pendingAiSummaries: pendingAiSummariesReducer,
  pendingBulkTakedowns: pendingBulkTakedownsReducer,
  pendingTakedownStatusUpdates: pendingTakedownStatusUpdatesReducer,
});

const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};

export default rootReducer;
